import React from 'react';

const ChatSection: React.FC = () => {
  return (
    <div className="flex items-center justify-center h-[calc(100vh-96px)] text-muted-foreground">
      Chat section coming soon 🚧
    </div>
  );
};

export default ChatSection; 